import { render } from "./painting-2.vue?vue&type=template&id=272fc21f&scoped=true"
import script from "./painting-2.vue?vue&type=script&lang=js"
export * from "./painting-2.vue?vue&type=script&lang=js"

import "./painting-2.vue?vue&type=style&index=0&id=272fc21f&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-272fc21f"]])

export default __exports__